import { useQuery } from "@tanstack/react-query";
import { getComoStatus } from "../../api/bComoApi";

export const useGetComoStatus = (organisationId, locationId=null, brandId=null, enabled = true) => {
  return useQuery({
    queryKey: ["como-status", organisationId, locationId, brandId],
    queryFn: () => getComoStatus(organisationId, locationId, brandId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
